import { Box, Button, Chip, Divider, Typography } from '@mui/material'
import { displayNamesOfEventTypes } from 'src/consumer/constants'
import { describeClinicFallbackTargeting } from 'src/mentor/components/MentorEventsPage/components/utils'

function getModeLabel(meetingSrc) {
  if (meetingSrc === 'aumhum') {
    return 'Video Call'
  }
  if (meetingSrc === 'home-visit') {
    return 'Home Visit'
  }
  return 'In Person'
}

export default function ClinicScreeningFallbackDetails({ fallbackEntry, onClose }) {
  if (!fallbackEntry) {
    return null
  }

  return (
    <Box sx={{ width: 420, maxWidth: '100%', p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {fallbackEntry?.title}
          </Typography>
          <Typography variant="body2" sx={{ color: '#6b7280', mt: 0.5 }}>
            {fallbackEntry?.clinicDisplayName}
          </Typography>
        </Box>
        <Chip label="Read Only" size="small" sx={{ bgcolor: '#fff7ed', color: '#9a3412', fontWeight: 600 }} />
      </Box>

      <Typography variant="body2" sx={{ color: '#6b7280' }}>
        {fallbackEntry?.helperText}
      </Typography>

      <Divider />

      <Box sx={{ display: 'grid', gridTemplateColumns: '140px 1fr', rowGap: 1.25, columnGap: 1.5 }}>
        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          Source
        </Typography>
        <Typography variant="body2">{fallbackEntry?.sourceLabel}</Typography>

        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          Event Type
        </Typography>
        <Typography variant="body2">{displayNamesOfEventTypes?.[fallbackEntry?.type] || fallbackEntry?.type}</Typography>

        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          Specialty
        </Typography>
        <Typography variant="body2">{fallbackEntry?.specialtyDisplayLabel || 'Psychiatry (Default)'}</Typography>

        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          Duration
        </Typography>
        <Typography variant="body2">{fallbackEntry?.durationInMins || '--'} mins</Typography>

        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          Meeting Mode
        </Typography>
        <Typography variant="body2">{getModeLabel(fallbackEntry?.meetingSrc)}</Typography>

        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          Applicability
        </Typography>
        <Typography variant="body2">{describeClinicFallbackTargeting(fallbackEntry)}</Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </Box>
    </Box>
  )
}
